<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="1100px" :destroy-on-close="true" :before-close="cancel">
    <div class="el-dialog-div">
      <div class="section-card">
        <div class="section-header-bar" @click="toggleSection('invoiceInfo')">
          <div class="section-title"><i class="el-icon-s-ticket"></i> 发票信息</div>
          <i :class="sectionOpen.invoiceInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div class="detail-grid" v-show="sectionOpen.invoiceInfo">
          <div class="detail-item">
            <span class="detail-label">状态</span>
            <span class="detail-value">
              <el-tag v-if="record.status === 'SUCCESS'" type="success" size="small">已通过</el-tag>
              <el-tag v-else-if="record.status === 'APPLYING'" type="warning" size="small">待审核</el-tag>
              <el-tag v-else-if="record.status === 'DEFEAT'" type="danger" size="small">已驳回</el-tag>
              <el-tag v-else type="info" size="small">未知状态</el-tag>
            </span>
          </div>
          <div class="detail-item" v-if="record.rejectionReason">
            <span class="detail-label">驳回原因</span>
            <span class="detail-value">{{ record.rejectionReason }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">创建人</span>
            <span class="detail-value">{{ record.createBy }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">创建时间</span>
            <span class="detail-value">{{ record.createTime }}</span>
          </div>
          <div class="detail-item" v-if="record.operatingPersonName">
            <span class="detail-label">审核</span>
            <span class="detail-value">{{ record.operatingPersonName }}</span>
          </div>
          <div class="detail-item" v-if="record.operatingTime">
            <span class="detail-label">发票审核时间</span>
            <span class="detail-value">{{ record.operatingTime }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">销售</span>
            <span class="detail-value">{{ record['applicant'].name }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">申请时间</span>
            <span class="detail-value">{{ record.applicationDate }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">是否连号</span>
            <span class="detail-value">
              <el-tag v-if="isConnected" type="success" size="small">是</el-tag>
              <el-tag v-else-if="isNotConnected" type="warning" size="small">否</el-tag>
              <el-tag v-else type="info" size="small">未知状态</el-tag>
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">是否同一天</span>
            <span class="detail-value">
              <el-tag v-if="isSameDay" type="success" size="small">是</el-tag>
              <el-tag v-else-if="isNotSameDay" type="warning" size="small">否</el-tag>
              <el-tag v-else type="info" size="small">未知状态</el-tag>
            </span>
          </div>
          <div class="detail-item" v-if="record['annex']">
            <span class="detail-label">试剂清单</span>
            <span class="detail-value">
              <div class="attachment-actions">
                <el-button size="mini" type="primary" icon="el-icon-download" plain @click="download(record.id, 'record')">下载</el-button>
                <el-button size="mini" type="primary" icon="el-icon-view" plain @click="preview(record.id, 'record')">预览</el-button>
              </div>
            </span>
          </div>
          <div class="detail-item full-width" v-if="record.sameDayFlag === 0">
            <span class="detail-label">开票日期备注</span>
            <span class="detail-value">{{ record.remark }}</span>
          </div>
        </div>
      </div>

      <div class="sub-section">
        <div class="sub-section-title">
          <span><i class="el-icon-money"></i> 合同金额详情</span>
        </div>
        <div>
          <div v-for="(contract, index) in record['contractInfoList']" :key="index" class="contract-detail-row">
            <span class="contract-index">{{ index + 1 }}</span>
            <div class="detail-grid" style="width: 100%!important;">
              <div class="detail-item">
                <span class="detail-label">合同名称</span>
                <span class="detail-value">{{ contract.contractName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">合同状态</span>
                <span class="detail-value">
                  <el-tag :type="statusMap.find(item => item.status === contract.status).type">{{ statusMap.find(item => item.status === contract.status).name }}</el-tag>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">合同编号</span>
                <span class="detail-value">{{ contract.contractNumber }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">合同金额</span>
                <span class="detail-value"><span class="amount-text">{{ formatAmount(contract.contractAmount) }}</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sub-section">
        <div class="sub-section-title">
          <span><i class="el-icon-document"></i> 开票具体详情</span>
        </div>
        <div>
          <invoice-info-dialog :select-detail="record" :principal-uuids="principalUuids"
            :person-options="PersonOptions" @submit="getPrincipal"></invoice-info-dialog>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
    </div>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
  </el-dialog>
</template>

<script>

import InvoiceInfoDialog from "@/components/invoice/InvoiceInfoDialog";
import FilePreview from "@/components/file/FilePreview.vue";
import { getPersonByType } from "@/api/dilivery/customer/person";
import detailCommonMixin from "@/mixins/detailCommonMixin";

export default {
  name: "RecordDetails",
  mixins: [detailCommonMixin],
  components: { FilePreview, InvoiceInfoDialog },
  props: ['showDialog', 'selectDetail'],
  data() {
    return {
      title: '查看发票记录信息详情',
      showFile: false,
      fileInfo: '',
      record: {},
      PersonOptions: [],
      principalUuids: {},
      sectionOpen: {
        invoiceInfo: true,
      },
      statusMap: [
        { status: 'SUCCESS', type: 'success', name: '已通过' },
        { status: 'APPLYING', type: 'warning', name: '待审核' },
        { status: 'EVALUATING', type: 'primary', name: '待评估' },
        { status: 'DEFEAT', type: 'danger', name: '已驳回' },
        { status: 'DERELICT', type: 'info', name: '废弃' },
      ],
    };
  },
  computed: {
    isConnected() {
      return (this.record?.connectedFlag) === 1;
    },
    isNotConnected() {
      return (this.record?.connectedFlag) === 0;
    },
    isSameDay() {
      return (this.record?.sameDayFlag) === 1;
    },
    isNotSameDay() {
      return (this.record?.sameDayFlag) === 0;
    },
  },
  watch: {
    selectDetail: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.record = { ...newVal };
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getPersonOptions();
  },
  methods: {
    getPrincipal(value) {
      this.principalUuids = value;
    },
    getPersonOptions() {
      getPersonByType('', { deptTypes: ["BUSINESS_COMMERCIAL"] }).then(res => {
        if (res.code === 200) {
          this.PersonOptions = res.data;
        }
      }).catch(error => {
        this.$messageUi.error('获取商务专员信息失败');
        console.log(error);
      });
    },
    cancel() {
      this.$emit('submit', 'cancel');
    },
    async download(id, type) {
      await this.downloadContractAttachment(id, type);
    },
    async preview(id, type) {
      await this.previewContractAttachment(id, type);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";

.el-dialog-div {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 5px;
}












</style>
